import { t } from 'i18next'

export const GUIDE_TITLE = t('guide.title')
